package org.btmonier.games.components

import kotlinx.html.*
import kotlinx.html.dom.create
import kotlinx.browser.document
import kotlinx.browser.window
import org.btmonier.games.model.Game
import org.btmonier.games.util.processInlineMarkdown
import org.w3c.dom.HTMLElement

fun createGamePage(game: Game): HTMLElement {
    val container = document.create.div("game-container") {
        // Go Back to Search Button
        div("game-back-button-container") {
            a(href = "/", classes = "md-button md-button-text game-back-button") {
                span("material-icons") { +"arrow_back" }
                +"Go Back to Search"
            }
        }
        
        // Game Header
        div("game-header") {
            h1("game-title") { +game.metadata.title }
            
            // Metadata
            val metadataItems = mutableListOf<Triple<String, String, String>>()
            
            game.metadata.status?.let {
                metadataItems.add(Triple("info", "Status:", it))
            }
            
            game.metadata.technology?.let {
                metadataItems.add(Triple("code", "Technology:", it))
            }
            
            game.metadata.date?.let {
                metadataItems.add(Triple("calendar_today", "Date:", it))
            }
            
            if (metadataItems.isNotEmpty()) {
                div("game-metadata") {
                    metadataItems.forEach { item ->
                        div("game-metadata-item") {
                            span("material-icons") { +item.first }
                            span("game-metadata-label") { +item.second }
                            span { +item.third }
                        }
                    }
                }
            }
        }
        
        // Tags
        if (game.metadata.tags.isNotEmpty()) {
            div("game-tags") {
                game.metadata.tags.forEach { tag ->
                    span("game-tag") { +tag }
                }
            }
        }
        
        // Description Section
        if (game.content.description.isNotBlank()) {
            div("game-section") {
                h2("game-section-title") {
                    span("material-icons") { +"description" }
                    +"Description"
                }
                div("game-description") {
                    p("game-description-text") {
                        unsafe { +processInlineMarkdown(game.content.description) }
                    }
                }
            }
        }
        
        // Features Section
        if (game.content.features.isNotEmpty()) {
            div("game-section") {
                h2("game-section-title") {
                    span("material-icons") { +"star" }
                    +"Features"
                }
                div("game-features") {
                    ul("game-features-list") {
                        game.content.features.forEach { feature ->
                            li("game-feature-item") {
                                span { unsafe { +processInlineMarkdown(feature) } }
                            }
                        }
                    }
                }
            }
        }
        
        // Controls Section
        if (game.content.controls.isNotEmpty()) {
            div("game-section") {
                h2("game-section-title") {
                    span("material-icons") { +"gamepad" }
                    +"Controls"
                }
                div("game-controls") {
                    ul("game-controls-list") {
                        game.content.controls.forEach { control ->
                            li("game-control-item") {
                                span { unsafe { +processInlineMarkdown(control) } }
                            }
                        }
                    }
                }
            }
        }
    }
    
    // Setup click handler for back button
    val backButton = container.querySelector(".game-back-button") as? HTMLElement
    backButton?.addEventListener("click", { e ->
        e.preventDefault()
        window.location.href = "/"
    })
    
    return container
}
